import { operators as o, common as c } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

interface BuildParams {
    appId: c.AppIdType;
    identified: string | boolean;
    blacklist: c.BlacklistTypes;
}

export default {
    name: 'mobile-visitors',
    productArea: PRODUCT_AREAS.MOBILE,
    subProductArea: SUB_PRODUCT_AREAS.ANALYTICS,
    responseFormat: 'rows',
    build: ({ appId, identified = true, blacklist = 'apply' }: BuildParams) => {
        return o.pipeline(
            o.sources.visitors({ identified, blacklist }),
            o.filter(`!isNil(metadata.auto_${appId}.lastuseragent)`),
            { useragent: { ua: `metadata.auto_${appId}.lastuseragent` } },
            o.select({ appVersion: 'ua.appVersion', sdkVersion: 'ua.sdkVersion' }),
            o.filter('!isNil(appVersion) && !isNil(sdkVersion)'),
            o.evaluate('sdkVersion', 'split(sdkVersion, ".")'),
            o.evaluate('sdkVersion', 'sdkVersion[0]+"."+sdkVersion[1]+"."+sdkVersion[2]'),
            o.group(['appVersion', 'sdkVersion'], o.groupField('count', o.count(null))),
            o.evaluate('appVersionOrder', '0'),
            o.merge(
                ['appVersion'],
                o.mappings({ appVersion: 'version', appVersionOrder: 'createdAt' }),
                o.pipeline({ source: { mobileapplicationversions: { appId } } }),
            ),
        );
    },
};
